// 降落航线
export default {
    landingRoute: 'Landing route',
    HDP: 'Height difference protection',
    generate: 'Generate',
    read: 'Read',
    clear: 'Clear',
}